import { useCallback, useMemo, useState } from "react"

import { DeviceDocument, useDevices } from "../../../contexts/devices-context"
import remove from "lodash.remove"
import useInferStatus from "./useInferStatus"

export type DeviceFilter = {
    name: string | null
    group: string | null
    status: string | null
    modules: string[] | null
}

export const INIT_DEVICES_FILTER: DeviceFilter = {
    name: null,
    group: null,
    status: null,
    modules: null,
}

export default () => {
    const { data } = useDevices()
    const inferStatus = useInferStatus()
    const [filter, setFilter] = useState(INIT_DEVICES_FILTER)
    const filtered = useMemo<DeviceDocument[]>(() => {
        const out = [...data]
        if (filter.name) remove(out, device => !device.name.toLowerCase().includes(filter.name!.toLowerCase()))
        if (filter.group) remove(out, device => device.group !== filter.group)
        if (filter.status) remove(out, device => inferStatus(device.health) !== filter.status)
        if (filter.modules) remove(out, device => !device.modules.some(module => filter.modules!.includes(module.name)))
        return out
    }, [data, filter, inferStatus])

    const setNameFilter = useCallback(
        (value: string | null) => setFilter({ ...filter, name: value }),
        [setFilter, filter],
    )
    const setGroupFilter = useCallback(
        (value: string | null) => setFilter({ ...filter, group: value }),
        [setFilter, filter],
    )
    const setStatusFilter = useCallback(
        (value: string | null) => setFilter({ ...filter, status: value }),
        [setFilter, filter],
    )
    const setModulesFilter = useCallback(
        (value: string[] | null) => setFilter({ ...filter, modules: value?.length ? value : null }),
        [setFilter, filter],
    )
    const resetFilter = useCallback(() => setFilter(INIT_DEVICES_FILTER), [])

    return { filter, filtered, setGroupFilter, setNameFilter, setStatusFilter, setModulesFilter, resetFilter }
}
